// The LP quiz hero passes the visitor's pain location (e.g. lower-back) in this
// parameter. It is health data, so app start takes it out of the address bar
// before the router or any analytics run. It then lives only in memory until
// the pre-signup entry guard takes it or the first navigation ends.
const LP_PAIN_LOCATION_PARAM = 'lp_pain_location'

let pendingLpPainLocation = null

/** Call first thing at app start, before the router and trackers start. */
export const consumeLpPainLocationFromUrl = () => {
  const url = new URL(window.location.href)
  if (!url.searchParams.has(LP_PAIN_LOCATION_PARAM)) return

  const values = url.searchParams.getAll(LP_PAIN_LOCATION_PARAM)
  // A repeated parameter isn't an answer the LP produces; drop it.
  pendingLpPainLocation = values.length === 1 ? values[0] : null
  url.searchParams.delete(LP_PAIN_LOCATION_PARAM)
  window.history.replaceState(
    window.history.state,
    '',
    url.pathname + url.search + url.hash,
  )
}

/** The LP pain location from this page load, once; afterwards null. */
export const takePendingLpPainLocation = () => {
  const value = pendingLpPainLocation
  pendingLpPainLocation = null
  return value
}
